import {computed, ref} from 'vue';
import {defineStore, storeToRefs} from 'pinia';
import {useAuth} from '#imports';

/**
 * Basic informations on connected user
 */
export const useUserStore = defineStore('user-store', () => {
    const authStore = useAuth();
    const {user} = storeToRefs(authStore);
    const userLocale = ref<string>('');

    const userName = computed(() => authStore.user?.username || '');
    const selectedIdentity = computed(() => authStore.user?.identities.find((identity) => identity.id === authStore.user?.selectedIdentity));
    const clientCompanyId = computed(() => selectedIdentity.value?.clientCompanyId || '');

    const isAdmin = computed(() => {
        if (selectedIdentity.value) {
            return selectedIdentity.value.admin;
        }
        return false;
    });

    const isPlatformAdmin = computed(() => {
        return authStore.hasEnoughPrivilege(['ROLE_ADMIN']);
    });

    const roles = computed(() => {
        return authStore.user?.roles || [];
    });

    const isFreelance = computed(() => selectedIdentity.value?.identityType === 'FREELANCE');

    const hasSubcontractorIdentity = computed(
        () => authStore.user?.identities.some((identity) => identity.identityType === 'SUBCONTRACTOR') ?? false,
    );

    const freelancerCompanyId = computed(() => {
        const userId = user.value?.selectedIdentity;
        const userInfo = user.value?.identities.find((i) => i.id === userId);
        return userInfo?.freelancerCompanyId;
    });

    return {
        isAdmin,
        user,
        isPlatformAdmin,
        userLocale,
        selectedIdentity,
        userName,
        roles,
        isFreelance,
        hasSubcontractorIdentity,
        clientCompanyId,
        freelancerCompanyId,
    };
});
